import React, { useState, useRef } from "react";
import {
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Typography,
  Chip,
} from "@mui/material";
import SectionCard from "./SectionCard";

const digitalImageOptions = [
  { key: "factoryNameBoard", label: "Factory Name board", group: "HR" },
  { key: "factoryPictureFull", label: "Factory Picture Full", group: "HR" },
  { key: "factoryEntrance", label: "Factory Entrance", group: "HR" },
  {
    key: "productionFloorPic1",
    label: "Production Floor - Pic 1",
    group: "QC",
  },
  { key: "productionFloorPic2", label: "Production floor -Pic 2", group: "QC" },
  {
    key: "productionFloorPic3",
    label: "Production Floor - Pic 3",
    group: "QC",
  },
  { key: "productionFloorPic4", label: "Production floor- Pic 4", group: "QC" },
  { key: "productionFloorPic5", label: "Production floor- Pic 5", group: "QC" },
  { key: "productionFloorPic6", label: "Production floor- Pic 6", group: "QC" },
  { key: "storageSectionPic1", label: "Storage Section -Pic 1", group: "QC" },
  { key: "storageSectionPic2", label: "Storage Section -Pic 2", group: "QC" },
  { key: "storageSectionPic3", label: "Storage Section -Pic 3", group: "QC" },
  {
    key: "firefightingEquipmentPic1",
    label: "Firefighting equipment-Pic 1",
    group: "HR",
  },
  {
    key: "firefightingEquipmentPic2",
    label: "Firefighting equipment-Pic 2",
    group: "HR",
  },
  {
    key: "firefightingEquipmentPic3",
    label: "Firefighting equipment-Pic 3",
    group: "HR",
  },
  { key: "othersPic1", label: "Others 1" },
  { key: "othersPic2", label: "Others 2" },
  { key: "othersPic3", label: "Others 3" },
];

const Step4AdditionalDetails = ({ formData, setFieldValue, disable }) => {
  const [selectedImageType, setSelectedImageType] = useState("");
  const fileInputRef = useRef(null);

  const fieldsEnabledQC = Boolean(disable?.isQCTeam || disable?.isAdmin);
  const fieldsEnabledHR = Boolean(disable?.isHRTeam || disable?.isAdmin);
  const fieldsEnabledFinance = Boolean(
    disable?.isFinanceTeam || disable?.isAdmin,
  );

  const filteredImageOptions = digitalImageOptions.filter((option) => {
    // Common images (no group defined)
    if (!option.group) return true;

    if (option.group === "QC" && fieldsEnabledQC) return true;
    if (option.group === "HR" && fieldsEnabledHR) return true;
    if (option.group === "Finance" && fieldsEnabledFinance) return true;

    return false;
  });

  const uploadedImages = filteredImageOptions.filter(
    (option) =>
      formData[option.key] !== null &&
      formData[option.key] !== undefined &&
      formData[option.key] !== "",
  );

  const handleImageUpload = (e) => {
    const file = e.target.files?.[0];
    if (file && selectedImageType && setFieldValue) {
      setFieldValue(selectedImageType, file);
      if (fileInputRef.current) fileInputRef.current.value = "";
    }
  };

  const handleImageRemove = (imageKey) => {
    if (setFieldValue) {
      setFieldValue(imageKey, null);
      if (imageKey === selectedImageType) setSelectedImageType("");
    }
  };

  return (
    <Grid container spacing={2}>
      <SectionCard title="Annexure - 1 Digital Images">
        <Grid container spacing={2}>
          <Grid item xs={12} auto>
            <FormControl fullWidth size="small">
              <InputLabel>Select Image Type</InputLabel>
              <Select
                value={selectedImageType}
                onChange={(e) => setSelectedImageType(e.target.value)}
                label="Select Image Type"
              >
                <MenuItem value="">
                  <em>Select an image type</em>
                </MenuItem>
                {filteredImageOptions.map((option) => {
                  const isUploaded =
                    formData[option.key] !== null &&
                    formData[option.key] !== undefined &&
                    formData[option.key] !== "";
                  return (
                    <MenuItem key={option.key} value={option.key}>
                      {option.label} {isUploaded && "✓"}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>

          {selectedImageType && (
            <Grid item xs={12} sm={6}>
              <Box
                sx={{ display: "flex", alignItems: "center", height: "100%" }}
              >
                {formData[selectedImageType] && (
                  <Chip
                    label={`Uploaded: ${formData[selectedImageType]?.name || "File"}`}
                    color="success"
                    size="small"
                    sx={{ mr: 1 }}
                  />
                )}
                <Typography variant="caption" color="text.secondary">
                  {formData[selectedImageType]
                    ? "You can select another type or replace this image"
                    : "Ready to upload"}
                </Typography>
              </Box>
            </Grid>
          )}

          <Grid item xs={12}>
            <Box>
              <input
                ref={fileInputRef}
                type="file"
                accept="image/*"
                onChange={handleImageUpload}
                disabled={!selectedImageType}
                id="digital-image-upload"
                style={{ width: "100%", padding: "8px" }}
              />
              {!selectedImageType && (
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ mt: 0.5, display: "block" }}
                >
                  Please select an image type from the dropdown above
                </Typography>
              )}
            </Box>
          </Grid>

          {uploadedImages.length > 0 && (
            <Grid item xs={12}>
              <Typography variant="subtitle2" sx={{ mb: 1, mt: 2 }}>
                Uploaded Images ({uploadedImages.length} of{" "}
                {digitalImageOptions.length}):
              </Typography>
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                {uploadedImages.map((option) => {
                  const imageFile = formData[option.key];
                  const fileName = imageFile?.name || "File";
                  const displayName =
                    fileName.length > 30
                      ? fileName.substring(0, 30) + "..."
                      : fileName;
                  return (
                    <Chip
                      key={option.key}
                      label={`${option.label} - ${displayName}`}
                      onDelete={() => handleImageRemove(option.key)}
                      color="primary"
                      variant="outlined"
                      sx={{ maxWidth: "100%" }}
                    />
                  );
                })}
              </Box>
            </Grid>
          )}
        </Grid>
      </SectionCard>
    </Grid>
  );
};

export default Step4AdditionalDetails;
